import type { AuthUser } from './auth'

export type ProfileUser = AuthUser

export type UpdateProfilePayload = {
  salutation: string
  first_name: string
  surname: string
  phone_number: string | null
  image?: File | null
  remove_image?: boolean
}

export type ChangePasswordPayload = {
  current_password: string
  password: string
  password_confirmation: string
}

export const SALUTATION_OPTIONS = [
  { value: 'miss', label: 'Miss' },
  { value: 'mr', label: 'Mr' },
  { value: 'mrs', label: 'Mrs' },
  { value: 'ms', label: 'Ms' },
  { value: 'dr', label: 'Dr' },
  { value: 'prof', label: 'Prof' },
] as const
